import { Application } from "@hotwired/stimulus"
import { current } from "./helpers/current_helpers.js"
import CurrentAccountMonitorController from "./controllers/current_account_monitor_controller"
import AttributeToggleController from "./controllers/attribute_toggle_controller"
import CloseWindowController from "./controllers/close_window_controller"

window.current = current

const application = Application.start()
application.debug = false
window.Stimulus = application

application.register("current-account-monitor", CurrentAccountMonitorController)
application.register("attribute-toggle", AttributeToggleController)
application.register("close-window", CloseWindowController)
